import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

interface FormHeaderProps {
  step: number;
  totalSteps: number;
}

const FormHeader: React.FC<FormHeaderProps> = ({ step, totalSteps }) => {
  const { t } = useLanguage();
  const pct = Math.round(((step + 1) / totalSteps) * 100);

  return (
    <div className="form-header-fixed">
      <div className="header-content">
        <div className="header-left">
          <h1 className="header-title">{t('form.title')}</h1>
        </div>
        
        <div className="header-right">
          <div className="header-progress">
            <div className="header-progress-bar">
              <div 
                className="header-progress-fill" 
                style={{ width: `${pct}%` }}
              />
            </div>
            <div className="header-progress-text">
              {t('form.progress.step')} {step + 1} {t('form.progress.of')} {totalSteps} · {pct}%
            </div>
          </div>
          
          <LanguageSwitcher />
        </div>
      </div>
    </div>
  );
};

export default FormHeader;
